import React from "react";
import { AlertCircle, KeyRound, BarChartBig } from "lucide-react";

type EmptyVariant = "no-data" | "not-configured" | "error";

interface ChartEmptyStateProps {
  variant?: EmptyVariant;
  title?: string;
  description?: string;
  hint?: string;
}

const variantConfig: Record<
  EmptyVariant,
  { icon: React.ReactNode; defaultTitle: string; defaultDescription: string }
> = {
  "no-data": {
    icon: <BarChartBig className="h-5 w-5 text-gray-700" />,
    defaultTitle: "No data to display",
    defaultDescription: "Try adjusting the date range or filters.",
  },
  "not-configured": {
    icon: <KeyRound className="h-5 w-5 text-gray-700" />,
    defaultTitle: "Connect to load analytics",
    defaultDescription:
      "Please Refresh the page.",
  },
  error: {
    icon: <AlertCircle className="h-5 w-5 text-gray-700" />,
    defaultTitle: "Unable to load chart",
    defaultDescription:
      "Something went wrong while fetching data. Please try again in a moment.",
  },
};

const ChartEmptyState: React.FC<ChartEmptyStateProps> = ({
  variant = "no-data",
  title,
  description,
  hint,
}) => {
  const cfg = variantConfig[variant];
  const resolvedTitle = title ?? cfg.defaultTitle;
  const resolvedDesc = description ?? cfg.defaultDescription;

  return (
    <div className="h-full w-full flex items-center justify-center">
      <div className="max-w-md w-full mx-auto flex flex-col items-center justify-center px-6 py-10 text-center border border-dashed border-gray-200 rounded-lg bg-gradient-to-b from-gray-50 to-white">
        <div className="flex items-center justify-center w-11 h-11 rounded-md border border-gray-200 bg-white shadow-sm mb-3">
          {cfg.icon}
        </div>
        <h4 className="text-sm font-semibold text-gray-900">{resolvedTitle}</h4>
        <p className="mt-1 text-sm text-gray-600">{resolvedDesc}</p>
        {hint ? (
          <p className="mt-3 text-xs text-gray-500 bg-white/70 border border-gray-200 rounded-md px-3 py-2">
            {hint}
          </p>
        ) : null}
      </div>
    </div>
  );
};

export default ChartEmptyState;

